var React = require('react');

function TiktokInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.714 4.40977C17.3552 3.63691 16.3742 2.40085 16.0684 0.959828C16.0022 0.648334 15.966 0.328024 15.966 0H11.6287L11.6215 15.1582C11.5486 16.8556 9.94673 18.218 7.98258 18.218C7.37223 18.218 6.79726 18.085 6.29137 17.8525C5.1309 17.3199 4.3369 16.259 4.3369 15.0384C4.3369 13.2851 5.97251 11.8588 7.98258 11.8588C8.35789 11.8588 8.71761 11.9128 9.05838 12.0057V8.14439C8.70581 8.10252 8.34778 8.07644 7.98258 8.07644C3.58123 8.0768 0 11.1998 0 15.0384C0 17.3937 1.3496 19.4779 3.40811 20.7382C4.70463 21.532 6.2821 22 7.983 22C12.3848 22 15.966 18.877 15.966 15.0384V7.35207C17.6669 8.41695 19.7511 9.04435 22 9.04435V5.26197C20.7886 5.26197 19.6601 4.94791 18.714 4.40977Z","fill":"currentColor"}));
}

TiktokInline.defaultProps = {"width":"50","height":"50","viewBox":"-14 -13 50 50","fill":"none"};

module.exports = TiktokInline;

TiktokInline.default = TiktokInline;
